import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { SectionHeading } from "./Section";
import { useLang } from "../../i18n";

export const Testimonials = () => {
  const { t } = useLang();
  const tt = t.testimonials;
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1);
  const len = tt.list.length;

  const go = useCallback((d) => {
    setDir(d);
    setI((prev) => (prev + d + len) % len);
  }, [len]);

  useEffect(() => {
    const id = setInterval(() => go(1), 6000);
    return () => clearInterval(id);
  }, [go]);

  const item = tt.list[i];

  return (
    <section className="relative py-24 md:py-36 bg-ink-surface/40 overflow-hidden" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1100px] px-6 md:px-12">
        <SectionHeading overline={tt.overline} title={tt.title} align="center" />

        <div className="relative mt-16 min-h-[280px] flex items-center justify-center">
          <Quote className="absolute -top-4 left-0 text-flame/15" size={120} strokeWidth={1} />
          <AnimatePresence mode="wait" custom={dir}>
            <motion.div
              key={i}
              custom={dir}
              initial={{ opacity: 0, x: dir * 60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir * -60 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="relative text-center"
              data-testid={`testimonial-${i}`}
            >
              <p className="font-heading text-2xl md:text-4xl font-bold leading-tight text-balance text-white/90">
                "{item.q}"
              </p>
              <div className="mt-8">
                <div className="font-semibold text-flame">{item.n}</div>
                <div className="text-sm text-white/45">{item.r}</div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6">
          <button onClick={() => go(-1)} data-cursor="hover" data-testid="testimonial-prev"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 hover:bg-flame hover:text-black transition-colors">
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {tt.list.map((_, idx) => (
              <button key={idx} onClick={() => { setDir(idx > i ? 1 : -1); setI(idx); }} data-cursor="hover"
                className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-flame" : "w-1.5 bg-white/20"}`}
                aria-label={`testimonial ${idx + 1}`} />
            ))}
          </div>
          <button onClick={() => go(1)} data-cursor="hover" data-testid="testimonial-next"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 hover:bg-flame hover:text-black transition-colors">
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
